import { IconName } from "../../Components/Landing/Icon";

export const img = (file: string) => `${process.env.PUBLIC_URL}/img/landingpage/${file}`;

const HeroBanner = img("HeroBanner.png");
const YardSigns = img("YardSigns.png");
const FoamCoreSigns = img("FoamCoreSigns.png");
const CustomBanners = img("CustomBanners.png");
const BusinessPromotions = img("BusinessPromotions.png");
const Events = img("Events.png");
const RealEstate = img("RealEstate.png");
const TradeShows = img("TradeShows.png");
const Schools = img("Schools.png");

export const navLinks = [
  { name: "Products", href: "#products" },
  { name: "How It Works", href: "#how" },
];

export const heroSlides = [
  { src: HeroBanner, alt: "Custom banner, yard sign and foam core print displayed outdoors" },
  { src: YardSigns, alt: "Yard sign on a lawn" },
  { src: CustomBanners, alt: "Custom banner on a fence" },
];

export const heroBadges: { icon: IconName; label: string }[] = [
  { icon: "truck", label: "Fast turnaround" },
  { icon: "award", label: "Vibrant full-color printing" },
  { icon: "shield", label: "Made for businesses & events" },
];

export const products = [
  {
    title: "Yard Signs",
    match: "yard",
    image: YardSigns,
    alt: "Yard sign on a lawn",
    description: "Eye-catching yard signs perfect for real estate, events, political campaigns and local businesses.",
    features: ["Multiple size options", "Corrugated plastic (weatherproof)", "Single or double-sided printing"],
    cta: "View details",
  },
  {
    title: "Foam Core Signs",
    match: "foam",
    image: FoamCoreSigns,
    alt: "Foam core print on display",
    description: "Lightweight and sturdy foam core prints for presentations, displays, point of purchase and more.",
    features: ["Multiple thickness options", "Smooth, professional finish", "Perfect for indoor use"],
    cta: "View details",
  },
  {
    title: "Create your Custom Banner",
    match: "banner",
    image: CustomBanners,
    alt: "Custom banner on a fence",
    description: "Durable, vibrant banners for businesses, events, promotions and more. Indoor or outdoor use.",
    features: ["Multiple sizes & materials", "Weather-resistant options", "Full-color, high-resolution printing"],
    cta: "Create Banner",
  },
];

export const steps: { icon: IconName; title: string; description: string }[] = [
  { icon: "laptop", title: "Choose Your Product", description: "Select banners, yard signs or foam core and customize your size, material and quantity." },
  { icon: "upload", title: "Upload Your Design", description: "Upload your file or use our design-ready templates to get started." },
  { icon: "box", title: "Review & Order", description: "Check your proof, confirm details and place your order with confidence." },
];

export const reasons: { icon: IconName; title: string; description: string }[] = [
  { icon: "piggy", title: "Budget-friendly pricing", description: "High-quality prints at prices that work for you." },
  { icon: "palette", title: "Vibrant full-color printing", description: "Sharp, professional results every time." },
  { icon: "gauge", title: "Fast turnaround", description: "Get your prints when you need them." },
  { icon: "headset", title: "Friendly support", description: "Our team is here to help with your order." },
];

export const occasions = [
  { name: "Business Promotions", image: BusinessPromotions },
  { name: "Events", image: Events },
  { name: "Real Estate", image: RealEstate },
  { name: "Trade Shows", image: TradeShows },
  { name: "Schools & Nonprofits", image: Schools },
];

// Placeholder profile URLs: replace with the real BudgetPrintPros accounts
export const socialLinks = [
  { name: "Facebook", href: "https://www.facebook.com/" },
  { name: "Instagram", href: "https://www.instagram.com/" },
  { name: "YouTube", href: "https://www.youtube.com/" },
];
